/*
 * @Author: your name
 * @Date: 2021-11-05 11:20:06
 * @LastEditTime: 2024-07-19 15:10:54
 * @LastEditors: lbb lhz6887@163.com
 * @Description: 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
 * @FilePath: \yhb_invite-download\src\api\index.js
 */
import {
	req,
	reqloading,
	rysReqloading,
	rysRequestXcx,
	kxsRequestXcx
} from '@/utils/request'
import axios from 'axios'
import { jsonp } from 'vue-jsonp'

// 上传图片
export function upload(data) {
	return req({ //需要loading加载
		url: '/file/upload',
		method: 'post',
		data: data
	})
}


// 需要loading
export function getuserInfos(obj) {
	return reqloading({ //需要loading加载
		url: '/List.php',
		method: 'get',
		params: obj,
	})
}

// 下载app 热更新修改版本新增updateLevel字段
export function downloadApp(data) {
	return reqloading({ //需要loading加载
		url: `/web/sys-version/newest?equipment=${data}&updateLevel=2`,
		method: 'get'
	})
}
// 下载app新版
export function downloadApps(data) {
	return reqloading({ //需要loading加载
		url: `/web/sys-version/getNewestApk?equipment=${data}`,
		method: 'get'
	})
}

//下载JSBAPP
export function jsbDownloadApp(data) {
	return reqloading({ //需要loading加载
		url: `/web/jsb/sys-version/newest?equipment=${data}`,
		method: 'get'
	})
}
//  获取注册页面的 隐私政策  
export function getRegisteredAgreement(data) {
	return reqloading({ //需要loading加载
		url: '/app/homeArticle/list',
		method: 'post',
		data: data
	})
}

//  获取注册页面的 隐私政策  
export function getLoaing(data) {
	return req({ //需要loading加载
		url: '/app/homeArticle/list',
		method: 'post',
		data: data
	})
}

// 获取 卡盒授权协议
export function khAuthorizationAgreement() {
	return reqloading({ //需要loading加载
		url: `/app/CreditCard/getAgreement?typeId=1`,
		method: 'get'
	})
}

//  用户注册服务协议 
export function khRegistrationAgreement() {
	return reqloading({ //需要loading加载
		url: `/app/CreditCard/getAgreement?typeId=2`,
		method: 'get'
	})
}

//  聚收宝用户注册服务协议 
export function JSBkhRegistrationAgreement(type) {
	return reqloading({ //需要loading加载
		url: `/app/feedback/getAgreement?typeId=${type}`,
		method: 'get'
	})
}

//  聚收宝小账本获取用户信息绑定 
export function getMpOpenId(data) {
	return reqloading({ //需要loading加载
		url: `/jsb/xzb/getMpOpenId`,
		method: 'post',
		data: data
	})
}

// 注册易伙伴App  /auth/app/register
export function register(data) {
	return reqloading({ //需要loading加载
		// url: '/auth/app/register', // 旧
		url: '/system/user/registers', // 新(同App)
		method: 'post',
		data: data
	})
}

//  获取验证码
export function getCode(phone) {
	return reqloading({ //需要loading加载
		url: `/auth/app/code?phoneNumber=${phone}`,
		method: 'get'
	})
}

// 信用卡记录 提交
export function Submit(data) {
	return reqloading({ //需要loading加载
		url: '/credit/credith5/addApply',
		method: 'post',
		data: data
	})
}

// 获取信用卡连接
export function link(data) {
	return reqloading({ //需要loading加载
		url: '/credit/app/link?code=' + data.code,
		method: 'get'
	})
}
// 获取文章详情
export function articleDetails(data) {
	return reqloading({ //需要loading加载
		url: '/app/businessSchool/articleDetails?id=' + data,
		method: 'get'
	})
}

// 获取如意刷隐私政策
export function getAgreement(data) {
	return rysReqloading({ //需要loading加载
		url: `/app/feedback/getAgreement?typeId=${data}`,
		method: 'get'
	})
}
// 人脸认证识别成功
export function face(mId, code) {
	return rysReqloading({ //需要loading加载
		url: `/rys/rpc/rysRegister/face?mId=${mId}&code=${code}`,
		method: 'get'
	})
}

// 人脸认证识别成功
export function facexcx(mId, code) {
	return rysRequestXcx({ //小程序单独请求
		url: `/rys/rpc/rysRegister/face?mId=${mId}&code=${code}`,
		method: 'get'
	})
}

// 意愿核身识别成功
export function will(mId, code) {
	return rysReqloading({ //需要loading加载
		url: `/rys/rpc/rysRegister/willFace?mId=${mId}&code=${code}`,
		method: 'get'
	})
}
// export function will(mId, code) {
//     return ScRequest({ //需要loading加载
//         url: `/app/notify/kdb/willFace?mId=${mId}&code=${code}`,
//         method: 'get'
//     })
// }

// 意愿核身识别成功
export function willxcx(mId, code) {
	return rysRequestXcx({ //小程序单独请求
		url: `/rys/rpc/rysRegister/willFace?mId=${mId}&code=${code}`,
		method: 'get'
	})
}

// 乐刷意愿核身识别成功
export function getWillIdentifyResult(orderNo, code) {
	return rysReqloading({
		url: `/rys/rysMerchantRegister/getWillIdentifyResult?serialNo=${orderNo}&code=${code}`,
		method: 'get'
	})
}
// 小程序意愿核身识别成功
export function getWillIdentifyResultxcx(orderNo, code) {
	return rysRequestXcx({ //小程序单独请求
		url: `/rys/rysMerchantRegister/getWillIdentifyResult?serialNo=${orderNo}&code=${code}`,
		method: 'get'
	})
}
//开心刷
export function getkxsWillIdentifyResultxcx(orderNo, code) {
	return kxsRequestXcx({ //小程序单独请求
		url: `/kxs/bindingCard/getWillIdentifyResult?serialNo=${orderNo}&code=${code}`,
		method: 'get'
	})
}
// 获取信用卡连接
export function getChatInfo(data) {
	return reqloading({ //需要loading加载
		url: '/chat/fineTunes/get-chat-info',
		method: 'post',
		data: data
	})
}

// 通过城市adcode获取城市信息
export function getCity(adcode) {
	return axios.get(
		`https://restapi.amap.com/v3/config/district?key=5a1ae477a13cd3cf142bae6f83eaf576&keywords=${adcode}&subdistrict=2`,
	)
}


// 腾讯地图服务通过IP定位
export function getWsLocationIP() {
	return jsonp('https://apis.map.qq.com/ws/location/v1/ip?', {
		key: 'KXFBZ-MQWCQ-MHC5Y-4UAHR-AALTF-2JB22',
		output: 'jsonp',

	})
}

// 根据腾讯位置服务获取地址信息
export function getWsLocation(location) {
	return req({
		url: `/merchant/address/queryAddressBy?lng=${location.longitude}&lat=${location.latitude}`,
		method: 'get',
	})
}

// 根据腾讯位置服务获取地址信息
export function getWsLocationAddress(address) {
	return req({
		url: `/merchant/address/queryLatitudeLongitude?address=${address}`,
		method: 'get',
	})
}

// 根据腾讯位置服务获取adcode信息
export function getWsLocationAdcodeInfo(adcode) {
	return req({
		url: `/merchant/address/queryLocation?keyword=${adcode}`,
		method: 'get',
	})
}


//  如意刷用户注册服务协议 
export function rysUserAgreement(type) {
	return reqloading({ //需要loading加载
		url: `/app/feedback/getAgreement?typeId=${type}`,
		method: 'get'
	})
}
// 通过资源id获取屏蔽省市
export function getShieldedArea(id) {
	return reqloading({ //需要loading加载
		url: `/credit/creditResourceBlockCity/queryBlockCityByResourceId?resourceId=${id}`,
		method: 'get'
	})
}
//  易伙伴人脸成功接口
export function setMerchProduct(data) {
	return rysReqloading({ //需要loading加载
		url: `/app/merchRegister/merchLiveOrder`,
		method: 'POST',
		data
	})
}
//  获取资源
export function getCreditTypeList(token) {
	return reqloading({ //需要loading加载
		url: `/credit/type/all`,
		headers: {
			Authorization: token
		},
		method: 'get'
	})
}
// 信用卡列表
export function getCreditList(data, token) {
	return reqloading({ //需要loading加载
		url: `/credit/app/page?typeId=${data}`,
		headers: {
			Authorization: token
		},
		method: 'get'
	})
}
// 参与活动资源列表
export function getParticipationCreditList(data, token) {
	return reqloading({ //需要loading加载
		url: `/credit/app/activityPage`,
		headers: {
			Authorization: token
		},
		method: 'get',
		params: data
	})
}

// 活动入口
export function getActivityEntry(data, token) {
	return reqloading({ //需要loading加载
		url: '/credit/creditActivityInfo/queryActivityTitle',
		method: 'post',
		headers: {
			Authorization: token
		},
		data: data
	})
}
// 数据列表
export function getDataList(pageNum, pageSize, data, token) {
	return reqloading({ //需要loading加载
		url: `/credit/creditActivityInfo/queryDataApp?pageNum=${pageNum}&pageSize=${pageSize}`,
		method: 'post',
		headers: {
			Authorization: token
		},
		data: data
	})
}
// 资源详情
export function getCreditDetail(data, token) {
	return reqloading({ //需要loading加载
		url: `/credit/app/query?creditId=${data}`,
		headers: {
			Authorization: token
		},
		method: 'get',
	})
}
// 抽奖次数
export function getPrizeLeftNum(data, token) {
	return reqloading({ //需要loading加载
		url: `/credit/creditActivityUser/prizeLeftNum`,
		method: 'get',
		params: data,
		headers: {
			Authorization: token
		},
	})
}
// 达标数据
export function queryCompleteCreditNum(data, token) {
	return reqloading({ //需要loading加载
		url: `/credit/app/queryCompleteCreditNum?activityId=${data}`,
		method: 'get',
		headers: {
			Authorization: token
		},
	})
}
// 获取中奖列表
export function getListofWinners(data, token) {
	return reqloading({ //需要loading加载
		url: `/credit/creditActivityPrizeLog/prizeLogList`,
		method: 'post',
		data: data,
		headers: {
			Authorization: token
		},
	})
}
// 获取奖品信息
export function getPrizeInformation(data, token) {
	return reqloading({ //需要loading加载
		url: `/credit/creditActivityPrize/prizeList`,
		method: 'get',
		params: data,
		headers: {
			Authorization: token
		},
	})
}
// 抽奖
export function getDrawward(data, token) {
	return reqloading({ //需要loading加载
		url: `/credit/creditActivityInfo/prizeReward`,
		method: 'get',
		params: data,
		headers: {
			Authorization: token
		},
	})
}
// 订单状态下拉
export function getOrderStatus(token) {
	return reqloading({ //需要loading加载
		url: `/credit/appOrderStatusInfo`,
		method: 'get',
		headers: {
			Authorization: token
		},
	})
}
// 申卡订单
export function getOrderList(pageNum, pageSize, data, token) {
	return reqloading({ //需要loading加载
		url: `/credit/app/orderList?pageNum=${pageNum}&pageSize=${pageSize}`,
		method: 'post',
		headers: {
			Authorization: token
		},
		data: data
	})
}
// 获取openid
export function getOpenidBycode(data) {
	return reqloading({ //需要loading加载
		url: `/credit/getOpenIdByCode?code=${data}`,
		method: 'get',

	})
}
// 信用卡容易申公众号注册新的用户
export function getrongYiShenRegister(data) {
	return reqloading({ //需要loading加载
		url: `/credit/rongYiShenRegister`,
		method: 'post',
		data: data
	})
}


/*
	一键注册模块
 */

//  获取验证码
export function getCode1(phone) {
	return req({
		url: `/auth/app/code?phoneNumber=${phone}`,
		method: 'get'
	})
}

// 注册接口
export function validMobile(data) {
	return req({
		url: `/merchant/merchRegister/h5/validMobile`,
		method: 'post',
		data: data
	})
}

// 获取省市区 /system/area/selectTree
export function getAddressCode() {
	return req({
		url: `/system/area/selectTree?channel=0`,
		method: 'get'
	})
}

// 图片上传
export function h5upload(data) {
	return req({
		url: `/file/h5/upload`,
		method: 'post',
		data
	})
}

// 身份证识别
export function h5IdentifyUrl(data) {
	return req({
		url: `/merchant/user/h5/identifyUrl`,
		method: 'post',
		data
	})
}

// 银行列表  
export function getBankList(num, data) {
	return req({
		url: `/app/merchBank/bankList?pageNum=${num}&pageSize=20`,
		method: 'post',
		data
	})
}

// 银行卡识别 
export function bankCartDiscern(data) {
	return req({
		url: `/merchant/user/h5/bankCartDiscern?imgUrl=${data}`,
		method: 'post',
	})
}

// 获取注册产列表
export function productList(data) {
	return req({
		url: `/merchant/merchRegister/h5/load/productList`,
		method: 'post',
		data
	})
}

// 绑机预校验 
export function bindingTermPreCheck(data, key) {
	return req({
		url: `/web/terminal/H5/registerMulti/bindingTermPreCheck?referKey=${key}`,
		method: 'post',
		data
	})
}

// H5 商户基础信息 提交
export function merchBase(data) {
	return req({
		url: `/merchant/merchRegister/h5/merchBase`,
		method: 'post',
		data
	})
}

// H5 身份证信息 提交
export function merchIdCard(data) {
	return req({
		url: `/merchant/merchRegister/h5/merchIdCard`,
		method: 'post',
		data
	})
}

// H5 结算信息 提交 
export function merchSettle(data) {
	return req({
		url: `/merchant/merchRegister/h5/merchSettle`,
		method: 'post',
		data
	})
}

// H5 其他信息 
export function merchTriplePhoto(data) {
	return req({
		url: `/merchant/merchRegister/h5/merchTriplePhoto`,
		method: 'post',
		data
	})
}

// 提交产品注册 
export function merchProduct(data) {
	return req({
		url: `/merchant/merchRegister/h5/merchProduct`,
		method: 'post',
		data
	})
}

// app 结算信息调用这个接口  
export function faceRecognition(data) {
	return req({
		url: `/kxs/KxsMerchant/h5/faceRecognition`,
		method: 'post',
		data
	})
}

// H5 通过任务ID获取一键注册任务 
export function getByTID(data) {
	return req({
		url: `/merchant/merchRegister/h5/getByTID`,
		method: 'post',
		data
	})
}

export function H5setMerchProduct(data) {
	return rysReqloading({ //需要loading加载
		url: `/merchant/merchRegister/h5/merchLiveOrder`,
		method: 'POST',
		data
	})
}

export function getWxConfig(url) {
	return req({
		url: `/merchant/merchRegister/getWechatJsTicketInfo?url=${url}`,
		method: 'get',
	})
}

// 商户端h5信用卡列表
export function getCreditListH5(data, token) {
	return reqloading({ //需要loading加载
		url: `/credit/app/merchant/page?typeId=${data}`,
		headers: {
			Authorization: token
		},
		method: 'get'
	})
}

// 根据id获取信用卡办卡链接
export function getJumpLinkUrl(data, token) {
	return reqloading({ //需要loading加载
		url: `/credit/app/merchant/query?creditId=${data}`,
		headers: {
			Authorization: token
		},
		method: 'get'
	})
}
// 商户端申卡订单
export function getMerchantOrderList(pageNum = 1, pageSize = 10, data, token) {
	return reqloading({ //需要loading加载
		url: `/credit/app/merchant/orderList?pageNum=${pageNum}&pageSize=${pageSize}`,
		method: 'post',
		headers: {
			Authorization: token
		},
		data: data
	})
}
// 商户端审贷订单列表
export function getLoansOrderList(pageNum, pageSize, data, token) {
	return reqloading({ //需要loading加载
		url: `/credit/app/merchant/orderCreditList?pageNum=${pageNum}&pageSize=${pageSize}`,
		method: 'post',
		headers: {
			Authorization: token
		},
		data: data
	})
}

//  统一隐私政策 
export function defaultAgreement(id) {
	return reqloading({
		url: `/app/feedback/getAgreement?typeId=${id}`,
		method: 'get'
	})
}

//  易伙伴道和提现查询接口
export function isLivenessAuth({ referKey , businessCode }) {
	return reqloading({
		url: `/third/payment/isLivenessAuth?referKey=${referKey}&businessCode=${businessCode}`,
		method: 'get'
	})
}

// 查询区号列表-注册使用
export function getAreaCodeList() {
	return reqloading({
		url: `/merchant//sms/country-dial/list`,
		method: 'get'
	})
}

// 短信包 验证码发送  /merchant/app/smsTreasureCode
export function sendSmsTreasureCode(data) {
	return reqloading({
		url: `/auth/app/smsTreasureCode`,
		method: 'post',
		data
	})
}
